
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="任务日期">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
                format="YYYY-MM-DD"
                v-model="queryParam.taskDate"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="负责人">
              <j-dict-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                pageSize="100"
                placeholder="请选择负责人"
                type="list"
                v-model="queryParam.manager"
              />
            </a-form-item>
          </a-col>
          <template>
            <a-col :span="6">
              <a-form-item label="任务状态">
                <j-checkbox :options="taskStatusOptions" @change="searchQuery" v-model="queryParam.taskStatus"></j-checkbox>
              </a-form-item>
            </a-col>
          </template>
          <a-col :span="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('日常检修任务')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>

        <span slot="manager" slot-scope="text,record">
          <a-button @click="showStatReport(record, 'personOverhaul', 'manager')" type="link">{{record.manager_dictText}}</a-button>
        </span>

        <span slot="ywDailyOverhaulItemList" slot-scope="text, record">
          <div :key="index" v-for="(item, index) in record.ywDailyOverhaulItemList">
            <a-tag>{{ (item.devName?(item.devName+':'):'')+item.workContent }}</a-tag>
          </div>
        </span>
        <span slot="statusSlot" slot-scope="taskStatus">
          <span v-if="taskStatus== '-1'">
            <a-tag color="#108ee9">编辑中</a-tag>
          </span>
          <span v-else-if="taskStatus== '0'">
            <a-tag color="#faad14">已发布</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">已完成</a-tag>
          </span>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="record.taskStatus === '-1'">编辑</a>
          <a-divider type="vertical" v-if="record.taskStatus === '-1'" />
          <a @click="handlePublish(record)" v-if="record.taskStatus === '-1'">发布</a>
          <a @click="handleExucute(record)" v-if="record.taskStatus === '0'">执行</a>
          <a @click="handleRecord(record)" v-if="record.taskStatus === '1'">查看</a>
        </span>
      </a-table>
    </div>

    <yw-daily-overhaul-task-modal @ok="modalFormOk" ref="modalForm" />
    <yw-daily-overhaul-task-execute-modal @ok="modalFormOk" ref="executeForm" />

    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </a-card>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import YwDailyOverhaulTaskModal from './modules/YwDailyOverhaulTaskModal'
  import YwDailyOverhaulTaskExecuteModal from './modules/YwDailyOverhaulTaskExecuteModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';

  export default {
    name: "YwDailyOverhaulTaskList",
    mixins: [JeecgListMixin],
    components: {
      YwDailyOverhaulTaskModal,
      YwDailyOverhaulTaskExecuteModal
    },
    data () {
      return {
        description: '日常检修任务管理页面',
        // 查询条件
        queryParam: {
          manager: '',
          taskDate: [],
          taskStatus: '',
        },
        taskStatusOptions: [
          {
            label: "编制中",
            value: "-1"
          }, {
            label: "已发布",
            value: "0"
          }, {
            label: "已完成",
            value: "1"
          }],
        isorter: {
          column: 'taskDate',
          order: 'desc'
        },
        // 表头
        columns: [
          {
            title: '任务日期',
            align: "center",
            dataIndex: 'taskDate',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            },
            sorter: true,
          },
          {
            title: '负责人',
            align: "center",
            dataIndex: 'manager',
            scopedSlots: { customRender: 'manager' },
          },
          {
            title: '检修内容',
            align: "center",
            dataIndex: 'ywDailyOverhaulItemList',
            scopedSlots: { customRender: 'ywDailyOverhaulItemList' },
          },
          {
            title: '参与人',
            align: "center",
            dataIndex: 'internalExecutor_dictText'
          },
          {
            title: '任务状态',
            align: "center",
            dataIndex: 'taskStatus',
            scopedSlots: { customRender: 'statusSlot' },
            sorter: true,
          },
          {
            title: '完成时间',
            align: "center",
            dataIndex: 'finishTime',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/maintenance/overhaul/list",
          delete: "/maintenance/overhaul/delete",
          deleteBatch: "/maintenance/overhaul/deleteBatch",
          exportXlsUrl: "/maintenance/overhaul/exportXls",
          edit: "/maintenance/overhaul/edit",
          editMain: "/maintenance/overhaul/editMain",
          getReportUrl: '/custom/commonOnlReport/list',
        },
        dictOptions: {},
        superFieldList: [],
        reportUrl: {},
      }
    },
    created () {
      this.getSuperFieldList();

      const that = this;
      getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
        if (res.success && res.result) {
          res.result.records.forEach(rep => {
            that.reportUrl[rep.shortName] = rep.url;
          });
        }
      });
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      handleRecord (record) {
        this.$refs.executeForm.edit(record)
        this.$refs.executeForm.title = '报告'
        this.$refs.executeForm.disableSubmit = true
      },
      handleExucute (record) {
        this.$refs.executeForm.edit(record)
        this.$refs.executeForm.title = '任务执行'
        this.$refs.executeForm.disableSubmit = false
      },
      handlePublish (record) {
        httpAction(this.url.editMain, Object.assign(record, { taskStatus: '0' }), 'put').then((res) => {
          if (res.success) {
            this.modalFormOk();
          }
        })
      },
      getQueryParams () {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        delete param.taskDate; // 时间参数不传递后台
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      onDateChange: function (value, dateString) {
        this.queryParam.taskDate_begin = dateString[0];
        this.queryParam.taskDate_end = dateString[1];
        this.searchQuery();
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'orderNumber', text: '单号', dictCode: '' })
        fieldList.push({ type: 'date', value: 'taskDate', text: '任务日期' })
        fieldList.push({ type: 'sel_user', value: 'manager', text: '负责人' })
        fieldList.push({ type: 'sel_user', value: 'internalExecutor', text: '内部执行人员' })
        fieldList.push({ type: 'string', value: 'externalExecutor', text: '外聘执行人员', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'taskStatus', text: '任务状态' })
        fieldList.push({ type: 'datetime', value: 'finishTime', text: '完成时间' })
        fieldList.push({ type: 'string', value: 'finishPerson', text: '实际完成人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'createBy', text: '发布人', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'createTime', text: '发布日期' })
        this.superFieldList = fieldList
      },
      showStatReport (record, reportKey, key) {
        let url = this.reportUrl[reportKey];
        if (!url) {
          this.$message.warning('未找到统计信息配置');
        }
        if (url.indexOf(`${key}`) > -1) {
          url = url.replace(`\$\{${key}\}`, record[key]);
        } else {
          url += `&${key}=${record[key]}`
        }
        this.$refs['iframeDrawer'].show(url);
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>